import React from 'react';
import dateFormat from 'dateformat';

const Messages = ({ messages, count }) =>
  <span>
    ({count})...{((messages && messages.edges) || []).map(({ node: message }, index) => (
      <span key={index}>{message.author.pseudo} ({message.created}): {message.text} ...</span>
    ))}
  </span>

// filter with
const withMessage = (messages) => messages.filter(({ node }) => node.messageCount)

class ChatTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeLine: null
    }
  }

  _highlightLine(index) {
    this.setState({activeLine: index});
  }

  _renderItem(item, index){

    let activeClass = (this.state.activeLine == index) ? 'active' : null;

    let {users, sportunity, messageCount, messages} = item.node;

    return (
      <tr className={activeClass}
        key={index}
        onClick={() => {this._highlightLine(index); this.props.onItemClick(item.node, index)}}>
          <td>{users.map(({pseudo}, index) => (
            <span key={index}>{pseudo}, </span>
          ))}</td>
          <td>
            {sportunity && (
              <span>{sportunity.title}, {sportunity.beginning_date}</span>
            )}
          </td>
          <td><Messages messages={messages} count={messageCount} /></td>
      </tr>
    );
  }

  render() {
    const dataSource = this.props.dataSource;

    return (
      <table className="table table-hover table-condensed">
        <thead>
          <tr>
            <th>Users</th>
            <th>Group</th>
            <th>Messages</th>
          </tr>
        </thead>

        <tbody>
          {withMessage(dataSource || []).map((item, index, arr) => this._renderItem(item, index))}
        </tbody>
      </table>
    )
  }


}

ChatTable.propTypes = ({
  dataSource : React.PropTypes.array.isRequired,
  onItemClick: React.PropTypes.func.isRequired,
});




export default ChatTable;



// WEBPACK FOOTER //
// ./src/components/ChatTable.js